import { Check } from 'lucide-react';
import { z } from 'zod';
import { Button } from '../Button/Button';
import { Form, useForm } from '../ui/Form';
import { Icon } from '../ui/Icon';
import { Input } from '../ui/Input';

const renameSchema = z.object({
  name: z.string(),
});
type RenameSchema = z.infer<typeof renameSchema>;

interface RenameFormProps {
  defaultValues: Partial<RenameSchema>;
  updateName: (name: string) => void;
  onSubmit: (values: RenameSchema) => void;
}

const RenameForm = ({
  defaultValues,
  onSubmit,
  updateName,
}: RenameFormProps) => {
  const form = useForm({
    schema: renameSchema,
    defaultValues,
  });

  return (
    <Form {...form}>
      <form
        className="flex gap-2 items-center"
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <Input
          autoFocus
          className="focus-visible:outline-none focus-visible:ring-0"
          placeholder="Enter new name"
          autoComplete="off"
          data-1p-ignore="true"
          data-lpignore="true"
          data-form-type="other"
          {...form.register('name', {
            onChange: (e) => updateName(e.target.value),
          })}
        />
        <Button size="icon" variant="secondary" className="flex-shrink-0">
          <Icon as={Check} />
        </Button>
      </form>
    </Form>
  );
};

export default RenameForm;
